<mat-table *ngIf="(binaries ?? []).length > 0" [dataSource]="binaries" class="w-100-p">
  <ng-container matColumnDef="applianceGroup">
    <th class="w-300" mat-header-cell *matHeaderCellDef scope="col">{{ 'APPLIANCE_GROUPS' | translate }}</th>
    <td mat-cell *matCellDef="let binary" class="text-center">
      {{ availableApplianceGroups[binary.applianceGroup] ? availableApplianceGroups[binary.applianceGroup].translatedName : '' }}
    </td>
  </ng-container>
  <ng-container matColumnDef="type">
    <th class="w-300" mat-header-cell *matHeaderCellDef scope="col">{{ 'TYPE' | translate }}</th>
    <td mat-cell *matCellDef="let binary" class="text-center">{{ binary.type }}</td>
  </ng-container>
  <ng-container matColumnDef="creationDate">
    <th class="w-300" mat-header-cell *matHeaderCellDef scope="col">{{ 'CREATION_DATE' | translate }}</th>
    <td mat-cell *matCellDef="let binary" class="text-center">{{ binary.creationDate | date : 'dd/MM/yyyy HH:mm' }}</td>
  </ng-container>
  <ng-container matColumnDef="createdBy">
    <th class="w-300" mat-header-cell *matHeaderCellDef scope="col">{{ 'CREATED_BY' | translate }}</th>
    <td mat-cell *matCellDef="let binary" class="text-center">
      {{ binary.creator }}
    </td>
  </ng-container>
  <ng-container matColumnDef="status">
    <th class="w-300" mat-header-cell *matHeaderCellDef scope="col">{{ 'STATUS' | translate }}</th>
    <td mat-cell *matCellDef="let binary" class="text-center">{{ binary.status | translate }}</td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th class="w-300" mat-header-cell *matHeaderCellDef scope="col" class="column-buttons"></th>
    <td mat-cell *matCellDef="let binary" class="column-buttons text-center">
      <ng-container *ngIf="binary.isInProgress; else actionButtons">
        <a class="action" matTooltip="{{ 'BINARIES.REFRESH' | translate }}" matTooltipClass="tooltip-main" (click)="reloadBinaries()">
          <i class="fas fa-sync" aria-hidden="true"></i>
        </a>
      </ng-container>

      <ng-template #actionButtons>
        <div class="row">
          <a class="action" matTooltip="{{ 'DOWNLOAD' | translate }}" matTooltipClass="tooltip-main" [href]="binary.link">
            <i class="fas fa-download" aria-hidden="true"></i>
          </a>
          <a
            class="action"
            *ngIf="binary.type !== 'USB' && binary.status !== 'PUBLISHED' && binary.applianceGroup"
            matTooltip="{{ 'PUBLISH' | translate }}"
            matTooltipClass="tooltip-main"
            (click)="publishBinary$.next(binary)"
          >
            <i class="fas fa-check" aria-hidden="true"></i>
          </a>
          <a
            class="action"
            *ngIf="binary.status !== 'PUBLISHED'"
            matTooltip="{{ 'DELETE' | translate }}"
            matTooltipClass="tooltip-main"
            (click)="deleteBinary$.next(binary)"
          >
            <i class="fas fa-trash" aria-hidden="true"></i>
          </a>
        </div>
      </ng-template>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</mat-table>
